export const DEFAULT_NAV_MENU = "QDEFAULT_NAV_MENU";
export const DEFAULT_HEADER_SECTION = "QDEFAULT_HEADER_SECTION";

export const PAGE_BEFORE_ID = "QPAGE_BEFORE";
export const PAGE_AFTER_ID = "QPAGE_AFTER";

export const TOP_HEADER_ID = "QUREAL_TOP_HEADER";
export const TOP_NAV_MENU = "QUREAL_NAV_MENU";
